<template>
    <v-row class="text-center">
      <v-col cols="12">
        <p>请指定参加绩效考核的部门和考核人</p>
        <div>
          <template>
            <v-data-table
                :headers="headers"
                :items="departmentsettings"
                sort-by="department"
                class="elevation-1"
            >
                <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title  class="text-caption">绩效考核部门考核人</v-toolbar-title>
                    <v-divider
                    class="mx-4"
                    inset
                    vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    
                    <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click.stop.prevent="insert"
                    >添加</v-btn>
                    
                    <v-btn
                        color="primary"
                        dark
                        class="mb-2 ml-2"
                        @click.stop.prevent="save"
                        >保存</v-btn>
                </v-toolbar>
                </template>
                <template v-slot:item.departmentname="{ item}">
                    <v-text-field readonly :value="item.departmentname" label="部门" append-icon="mdi-magnify" solo flat class="text-caption"
                                        @click:append='searchDepartment(item)'></v-text-field>
                </template>
                <template v-slot:item.members="{ item }">
                    <v-text-field readonly :value="getMembersString(item)" label="部门成员" append-icon="mdi-magnify" solo flat class="text-caption"
                                        @click:append='searchMembers(item)'></v-text-field>
                </template>
                <template v-slot:item.supervisorname="{ item }">
                    <v-text-field readonly :value="item.supervisorname" label="考核人" append-icon="mdi-magnify" solo flat class="text-caption"
                                        @click:append='searchSupervisor(item)'></v-text-field>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon
                        small
                        @click.stop.prevent="deleteItem(item)"
                    >
                        mdi-delete
                    </v-icon>
                </template>
                <template v-slot:no-data>
                    <span>请添加部门考核人</span>
                </template>
            </v-data-table>
            </template>
        </div>
      </v-col>
    </v-row>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ddhelper from '@/utils/ddhelper.js'

    export default {
        name: 'SysConfig',

        data: () => ({
            headers: [
                {
                    text: '部门',
                    align: 'start',
                    sortable: true,
                    value: 'departmentname'
                },
                {
                    text: '考核人',
                    align: 'start',
                    sortable: true,
                    value: 'supervisorname'
                },
                {
                    text: '部门成员',
                    align: 'start',
                    sortable: true,
                    value: 'members'
                },
                {
                    text: '查看人',
                    value: 'viewers',
                },
                { text: '操作', value: 'actions', sortable: false }
            ],
            departmentsettings: [],
            editedIndex: -1,
            editedItem: {
                _id:null,
                departmentid: '',
                departmentname: '',
                supervisorid: '',
                supervisorname: ''
            },
            defaultItem: {
                _id:null,
                departmentid: '',
                departmentname: '',
                supervisorid: '',
                supervisorname: ''
            },
            dialog:false
        }),
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? '添加部门考核人' : '修改部门考核人'
            },
            ...mapGetters(['client'])
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        created () {
            this.initialize()
        },
        methods: {
            initialize: async function  () {
                this.service = this.client.service('departmentsettings')
                this.service.on('updated', this.entryUpdated)
                this.service.on('removed', this.entryRemoved)

                const response = await this.service.find()
                this.departmentsettings = response.data
            },

            deleteItem (item) {
                // const index = this.departmentsupervisors.indexOf(item)
                confirm('确定删除这个部门吗?') && this.service.remove(item._id)
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            searchDepartment: async function (item) {
                const editedItem = item
                const result = await ddhelper.selectDepartmentAndUser(100)
                if (result.departments && result.departments.length > 0) {
                    editedItem.departmentname = result.departments[0].name
                    editedItem.departmentid = result.departments[0].id
                    editedItem.departmentmembers = result.users
                }
            },

            async searchMembers(item) {
                const result = await ddhelper.selectUser(100, item.departmentmembers.map(u=>u.userid))
                if (result && result.length) {
                    item.departmentmembers = result
                }
            },

            searchSupervisor: async function (item) {
                const editedItem = item
                
                const users = await ddhelper.selectUser(100)
                if (users) {
                    editedItem.supervisorname = users[0].username
                    editedItem.supervisorid = users[0].userid
                }
            },

            entryUpdated(entry) {
                const item = this.departmentsettings.find(item => item._id === entry._id)
                if (item) {
                    Object.assign(item, entry)
                }
            },

            entryRemoved(entry) {
                const index = this.departmentsettings.findIndex(item => item._id === entry._id)
                if (index > -1) {
                    this.departmentsettings.splice(index, 1)
                }
            },

            getMembersString(item) {
                if (!item.departmentmembers) return ''

                if (item.departmentmembers.length == 0) return '(空)'

                return item.departmentmembers.reduce((acc, mem)=> `${acc}, ${mem.name}`, `共(${item.departmentmembers.length})人`)
            },

            insert() {
                this.departmentsettings.push({
                    departmentid:null,
                    departmentname:'',
                    supervisorid:null,
                    supervisorname:'',
                    departmentmembers:[]
                })
            },

            async save () {

                for (let i = 0; i < this.departmentsettings.length; i++) {
                    const ds = this.departmentsettings[i]

                    if (ds._id) {
                        await this.service.update(ds._id, ds)
                    } else {
                        await this.service.create(ds)
                    }
                }

                this.$store.dispatch('loadDepartmentSettings')
                this.close()
            }
        }
    }
</script>